import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

import { ButtonModule } from 'primeng/button';

import { TranslocoPipe } from '@jsverse/transloco';

import { MessageStateConfig } from './message-state.interface';

const SEVERITY_DEFAULTS: Record<string, { icon: string; title?: string; message: string }> = {
  info: { icon: 'pi pi-inbox', message: 'COMMON.NO_DATA' },
  warn: { icon: 'pi pi-exclamation-circle', message: 'COMMON.WARN_DESCRIPTION' },
  error: {
    icon: 'pi pi-exclamation-triangle',
    title: 'COMMON.ERROR_TITLE',
    message: 'COMMON.ERROR_LOAD_DESCRIPTION',
  },
};

@Component({
  selector: 'nbx-message-state',
  standalone: true,
  imports: [TranslocoPipe, ButtonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex flex-1 min-h-0' },
  templateUrl: './message-state.component.html',
})
export class MessageStateComponent {
  protected readonly severity = computed(() => this.config().severity ?? 'info');
  protected readonly icon = computed(
    () => this.config().icon ?? SEVERITY_DEFAULTS[this.severity()].icon
  );
  protected readonly title = computed(
    () => this.config().title ?? SEVERITY_DEFAULTS[this.severity()].title
  );
  protected readonly message = computed(
    () => this.config().message ?? SEVERITY_DEFAULTS[this.severity()].message
  );
  protected readonly actionLabel = computed(() => this.config().actionLabel);
  protected readonly actionIcon = computed(() => this.config().actionIcon);

  config = input<MessageStateConfig>({});

  action = output<void>();
}
